import React from 'react';
import { Button } from './ui/button';
import { Phone, MessageCircle, ArrowRight } from 'lucide-react';
import { contactInfo } from '../data/mock';

const ContactCTA = () => {
  const whatsappLink = `https://wa.me/${contactInfo.whatsapp.replace(/\s+/g, '').replace('+', '')}`;

  return (
    <section id="contact" className="py-16 md:py-24 bg-gradient-to-br from-amber-500 to-amber-600 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-white rounded-full blur-3xl" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
          Plan Your Trip with
          <span className="block">Khoushik Tours & Travels</span>
        </h2>
        <p className="text-amber-100 text-lg md:text-xl max-w-2xl mx-auto mb-10">
          Call or WhatsApp us to get the best price for your journey. We'll help you choose the right vehicle and plan your travel smoothly.
        </p>

        {/* Contact Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a href={`tel:${contactInfo.phone1}`}>
            <Button className="bg-white text-amber-600 hover:bg-amber-50 px-8 py-6 text-lg rounded-xl shadow-lg shadow-amber-700/30 hover:shadow-xl transition-all duration-300 w-full sm:w-auto">
              <Phone className="w-5 h-5 mr-2" />
              Call: {contactInfo.phone1}
            </Button>
          </a>
           <a href={`tel:${contactInfo.phone2}`}>
            <Button className="bg-white text-amber-600 hover:bg-amber-50 px-8 py-6 text-lg rounded-xl shadow-lg shadow-amber-700/30 hover:shadow-xl transition-all duration-300 w-full sm:w-auto">
              <Phone className="w-5 h-5 mr-2" />
              Call: {contactInfo.phone2}
            </Button>
          </a>
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
            <Button className="bg-green-500 hover:bg-green-600 text-white px-8 py-6 text-lg rounded-xl shadow-lg shadow-green-700/30 hover:shadow-xl transition-all duration-300 w-full sm:w-auto">
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp Booking
            </Button>
          </a>
        </div>

        {/* Additional CTA */}
        <Button 
          variant="outline" 
          className="border-2 border-white/50 text-white hover:bg-white/10 px-8 py-6 text-lg rounded-xl transition-all duration-300"
        >
          Book Now
          <ArrowRight className="w-5 h-5 ml-2" />
        </Button>
      </div>
    </section>
  );
};

export default ContactCTA;
